export enum ExpirationReasonEnum {
  ExpirationDate = 1,
  StockUnderMinimum = 2,
  ExpiredAndUnderMinimum = 3,
}

export enum DueListModules {
  UserCompetence = 'UserCompetence',
  MaintenanceJob = 'MaintenanceJob',
  Document = 'Document',
  Drill = 'Drill',
  Work = 'Work',
  Certificate = 'Certificate',
  NonConformance = 'Report',
  NonConformanceSubtask = 'ReportSubtask',
  Runtime = 'Runtime',
  RiskAssessment = 'RiskAssessment',
  Medicine = 'Medicine',
  SignOffPeriod = 'Sign off document',
  AdditionalTime = 'Pending additional time',
  WorkSchedule = 'Work schedule',
  CorrectiveAction = 'CorrectiveAction',
}

export interface IDueListItem {
  category: DueListModules;
  name: string;
  id: string;
  componentId?: string;
  nonConformanceId?: string;
  expires: string;
  status: string;
  departmentId?: string;
  responsibles?: string[];
  expirationReason?: ExpirationReasonEnum;
  userId?: string;
  isPaused?: boolean;
  estimatedExpiryDate?: string;
}

export interface IDueListCompetence extends IDueListItem {
  isRegistrationCompleted: boolean;
  hasUserThisCompetence: boolean;
}
